import axios from 'axios';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    updatevalas(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                
                await axios.put(`appaymplan/exchrate/${obj.tukarkey}`, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    updateexchrate(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                
                await axios.post(`appaymplan/updateexchrate`, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl1', 'createby', 'aktif'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/appaymplan${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`appaymplan/detail/${obj.payplankey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    export(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['payplankey', 'createdate'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
    
                axios({
                    url: `/appaymplan/export${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `ap_payment_plan_${obj.createdate}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // if (obj.frmmode=='add'){
                    const { data } = await axios.post("appaymplan", obj);
                    resolve(data);
                // } else {
                //     const { data }  = await axios.put(`appaymplan/${encodeURIComponent(obj.kode)}`, obj);
                //     resolve(data);
                // }
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    saveplandtl(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                    const { data } = await axios.post("appaymplan/plandtl", obj);
                    resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log(`appaymplan/${obj.payplankey}`);
                const { data } = await axios.delete(`appaymplan/${encodeURIComponent(obj.payplankey)}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    outstanding(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/appaymplan/outstanding${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    outstandingexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = [ 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
    
                axios({
                    url: `/appaymplan/outstandingexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `ap_outstanding_finance_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    outstandgroup(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/appaymplan/outstandgroup${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    outstandgroupexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = [ 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
    
                axios({
                    url: `/appaymplan/outstandgroupexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `ap_outstanding_finance_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
};